import { useEffect } from 'react'
import { useLocation } from 'react-router-dom'

export default function ScrollToTop() {
  const { pathname } = useLocation()

  useEffect(() => {
    // If returning to a boat list page and we have a saved scroll position,
    // let BoatsPage handle restoring the exact scroll position smoothly.
    const isBoatList =
      pathname === '/baade' ||
      pathname === '/motorbaade' ||
      pathname === '/sejlbaade' ||
      pathname === '/motorsejlere'

    let hasSavedScroll = false
    try {
      hasSavedScroll = Boolean(sessionStorage.getItem('nordfyn_boats_scroll_pos'))
    } catch (e) {}

    if (isBoatList && hasSavedScroll) {
      return
    }

    window.scrollTo({ top: 0, behavior: 'instant' })
  }, [pathname])

  return null
}
